var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrazil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    width: 409,
    height: 409,
    viewBox: "0 0 409 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2442_9061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.100098 329.6C0.100098 246.6 0.100098 163.6 0.100098 80.6C0.800098 77.8 0.800099 74.8 1.0001 72C2.2001 57.7 8.9001 45.7 17.4001 34.5C29.5001 18.7 45.2001 8 64.4001 2.5C71.3001 0.5 78.6001 0.399994 85.7001 0.399994C164.8 0.299994 244 0.400003 323.1 0.300003C344.3 0.300003 362.6 7.19999 378.6 20.9C392.4 32.7 401.9 47.3 407 64.7C409 71.5 409.1 78.6 409.1 85.6C409.2 165.3 409.1 244.9 409.2 324.6C409.2 345.4 402.1 363.2 388.9 378.9C377.8 392.1 364 401.1 347.8 406.7C342.2 408.6 336.3 408.4 330.5 408.9C329.7 409 328.9 408.8 328.2 409.3C245.5 409.3 162.7 409.3 80.0001 409.3C76.9001 408.4 73.7001 408.5 70.6001 408.3C58.5001 407.4 48.2001 401.9 38.5001 395.4C21.7001 384.1 10.1001 368.6 3.3001 349.4C1.2001 343.5 1.4001 337.4 0.700096 331.4C0.400096 330.8 0.600098 330.1 0.100098 329.6Z",
    fill: "#72AE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.7 371.4C203.1 371.2 202.5 370 201.7 369.2C188.1 355.7 174.6 342.1 161.1 328.6C120.9 288.4 80.8001 248.3 40.6001 208.2C38.1001 205.7 38.1001 204.5 40.6001 202C94.3001 148.5 147.9 94.9 201.4 41.2C204 38.6 205.2 39 207.6 41.3C261.1 94.9 314.6 148.4 368.2 201.8C370.8 204.4 370.8 205.7 368.2 208.3C314.6 261.7 261.1 315.3 207.6 368.8C206.6 369.7 205.6 370.6 204.7 371.4Z",
    fill: "#FEE05A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.8 230.1C260.2 254.1 235.6 272.5 210.1 273.9C174.5 276 145.7 255 137.1 220.4C134.4 209.4 134.8 198.3 137.7 187.3C142.4 184.8 147.6 185.1 152.4 185.2C164.4 185.5 176.5 186.7 188.3 189.1C212 193.7 234.1 202.3 254.2 216C257.8 218.5 261.2 221.2 264.5 224.1C266.5 225.6 268 227.6 268.8 230.1Z",
    fill: "#41479A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.3 169.7C155.8 152 171.3 140.9 191.4 137.3C229.3 130.6 262.5 152.5 271.8 189.8C273.5 196.7 274.1 203.7 273.1 210.7C271.2 211.6 269.8 210.6 268.4 209.6C243.1 189.8 213.9 179.3 182.5 174.2C172 172.5 161.5 171.6 150.8 171.7C148.8 171.8 146.4 172.3 145.3 169.7Z",
    fill: "#41479A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.3 169.7C168.7 169.4 191.6 172.5 214 179.5C234.8 186 254.1 195.6 271.1 209.4C271.7 209.9 272.4 210.3 273.1 210.7C273 217.4 271.1 223.8 268.8 230C257.9 220.2 246 211.8 232.8 205.5C210.1 194.7 186.2 189.1 161.2 187.4C153.4 186.9 145.6 187.6 137.7 187.2C139.5 181.1 141.7 175.1 145.3 169.7Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.6 228.6L208.6 234.9H215.3L209.9 238.8L211.9 245.2L206.6 241.2L201.2 245.2L203.2 238.8L197.8 234.9H204.5L206.6 228.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 229.2L167.2 232.7H170.9L167.9 234.9L169 238.5L166 236.3L163 238.5L164.1 234.9L161.1 232.7H164.8L166 229.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.7 213.9L170.4 216H172.6L170.8 217.3L171.5 219.4L169.7 218.1L168 219.4L168.6 217.3L166.9 216H169.1L169.7 213.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.3 243.6L242.9 245.7H245.1L243.4 247L244 249.1L242.3 247.8L240.5 249.1L241.2 247L239.4 245.7H241.6L242.3 243.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.2 201.9L156.8 204H159L157.3 205.3L157.9 207.4L156.2 206.1L154.4 207.4L155.1 205.3L153.3 204H155.5L156.2 201.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.2 215.8L153.9 218.1H156.3L154.4 219.4L155.1 221.7L153.2 220.3L151.3 221.7L152 219.4L150.1 218.1H152.5L153.2 215.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.1 219L197.9 221.2H200.2L198.3 222.6L199 224.9L197.1 223.5L195.2 224.9L195.9 222.6L194 221.2H196.4L197.1 219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.9 242.9L190.7 245.2H193L191.1 246.6L191.9 248.9L189.9 247.5L188 248.9L188.7 246.6L186.8 245.2H189.2L189.9 242.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.5 243.5L230.2 245.8H232.6L230.7 247.2L231.4 249.4L229.5 248L227.6 249.4L228.3 247.2L226.4 245.8H228.7L229.5 243.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.4 174L232.2 176.3H234.6L232.6 177.7L233.4 179.9L231.4 178.5L229.5 179.9L230.3 177.7L228.3 176.3H230.7L231.4 174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.9 230.3L249.6 232.5H252L250.1 233.9L250.8 236.2L248.9 234.8L247 236.2L247.7 233.9L245.8 232.5H248.2L248.9 230.3Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2442_9061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 409,
    height: 409,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazil);
export default __webpack_public_path__ + "static/media/brazil.5f0151652d7a9e56ea31712f5b3d769d.svg";
export { ForwardRef as ReactComponent };